import { IApplicationState } from '../../types/redux';
import { getCountsForDealType, getCountsForEntityType } from '../../utils/filters';

export const selectTotalCount = (state: IApplicationState) => {
  const {
    filters: { dealType, favoriteEntityType },
    results: { total },
    counts,
  } = state;

  return counts
    ? favoriteEntityType
      ? getCountsForEntityType(counts, dealType, favoriteEntityType)
      : getCountsForDealType(counts, dealType)
    : total;
};
